"use strict";

exports.__esModule = true;
exports.AppNavbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isInIFrame = require("../../../Utils/isInIFrame");
var _Navbar = require("../../Core/Navbar");
var _SettingsMenu = require("../SettingsMenu");
var _NavbarSettingsMenuContext = require("./NavbarSettingsMenuContext");
var _NotificationsIcon = require("../../LandingScreen/NotificationsIcon");
var _AIChatDialog = _interopRequireDefault(require("../../Chat/AI/AIChatDialog"));
var _Auth = require("../../Auth");
var _UiModeToggle = require("../../UiPreferences/UiModeToggle");
var _excluded = ["showSettingsMenu", "showNotifications", "showAIChat", "showUiToggle", "settingsMenu", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Application NavBar
 */
var AppNavbar = exports.AppNavbar = function AppNavbar(props) {
  var _props$showSettingsMe = props.showSettingsMenu,
    showSettingsMenu = _props$showSettingsMe === void 0 ? true : _props$showSettingsMe,
    _props$showNotificati = props.showNotifications,
    showNotifications = _props$showNotificati === void 0 ? true : _props$showNotificati,
    _props$showAIChat = props.showAIChat,
    showAIChat = _props$showAIChat === void 0 ? true : _props$showAIChat,
    _props$showUiToggle = props.showUiToggle,
    showUiToggle = _props$showUiToggle === void 0 ? showSettingsMenu : _props$showUiToggle,
    _props$settingsMenu = props.settingsMenu,
    settingsMenu = _props$settingsMenu === void 0 ? _SettingsMenu.SettingsMenu : _props$settingsMenu,
    children = props.children,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var _useContext = (0, _react.useContext)(_NavbarSettingsMenuContext.NavbarSettingsMenuContext),
    navbarSettingsMenu = _useContext.settingsMenu,
    appList = _useContext.appList,
    showApps = _useContext.showApps;
  var Settings = navbarSettingsMenu ? navbarSettingsMenu : settingsMenu;
  var Apps = appList;
  return (0, _isInIFrame.isInIFrame)() ? null : /*#__PURE__*/_react["default"].createElement(_Navbar.Navbar, _extends({
    "data-testid": "AppNavbar"
  }, extra), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginRight: "10px"
    }
  }, children), showUiToggle && /*#__PURE__*/_react["default"].createElement(_UiModeToggle.UiModeToggle, null), showApps && Apps ? /*#__PURE__*/_react["default"].createElement(Apps, {
    style: {
      marginRight: "10px"
    }
  }) : null, showNotifications ? /*#__PURE__*/_react["default"].createElement(_NotificationsIcon.NotificationsIcon, null) : null, /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
    permission: "AI_CHAT"
  }, function (_ref) {
    var isAllowed = _ref.isAllowed;
    if (isAllowed && showAIChat) {
      return /*#__PURE__*/_react["default"].createElement(_AIChatDialog["default"], null);
    } else {
      return null;
    }
  }), showSettingsMenu && /*#__PURE__*/_react["default"].createElement(Settings, null)));
};